<h1 class="ap-blue">{{'ml_144074' | translate}}</h1>

@if(!(commonDataLoading$ | async)) {
<app-smart-search-form [defaultSearchCriteria$]="defaultSearchCriteria$" [formPath]="formPath"
  [searchByList]="orgUnitSearchByList$ | async" [onSearch]="onSearch" [searching$]="searching$"></app-smart-search-form>
}

@if(!(commonDataLoading$ | async) && isEditable$ | async) {
<div class="row ms-0 mb-2">
  <div class="col p-0">
    <button (click)="onCreate()" class="button--default me-3">{{ 'ml_144036' | translate }}</button>
    <button (click)="onDelete()" [disabled]="selectedItems.length === 0" class="button--default button-error me-3">{{
      'ml_143926' | translate }}</button>
  </div>
</div>
}

<app-message-data [errorMsg$]="unAssignedTerminalError$"></app-message-data>
<app-message-data [errorMsg$]="errorMessage$"></app-message-data>

<app-data-grid [isServerSidePagingFiltering]="true" [onLoadServerSideData]="onGetData"
  [totalCountForServerSidePagingFiltering$]="totalCount$"
  [isLoading]="(searching$ | async) || (commonDataLoading$ | async)" [dataSource$]="dataSource$"
  [defaultPageFilterSetting]="currentPageFilterSetting$ | async" [columnsDef]="dataGridColumnDef"
  [enableRowSelect]="true" (rowSelected)="rowSelected($event)"></app-data-grid>